import React from "react";
import { Spin } from "antd";

const LogoSpinnerVerticalCoin: React.FC = () => {
  return (
    <>
      <style>
        {`
          @keyframes verticalCoinSpin {
            0% {
              transform: rotateY(0deg);
            }
            100% {
              transform: rotateY(360deg);
            }
          }
        `}
      </style>

      <Spin
        indicator={
          <div
            style={{
              width: 120,
              height: 120,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              perspective: "1000px",
            }}
          >
            <img
              src="/assets/img/logo.png"
              alt="Loading"
              style={{
                width: 30,
                height: 30,
                transformStyle: "preserve-3d",
                animation: "verticalCoinSpin 1.2s linear infinite",
                filter: "drop-shadow(0 6px 6px rgba(0,0,0,0.3))",
              }}
            />
          </div>
        }
      />
    </>
  );
};

export default LogoSpinnerVerticalCoin;
